import React, { useContext } from 'react';
import { getStyles } from './HeaderButton.style';
import { IHeaderButtonProps } from './HeaderButton.types';
import { CommandBarButton, concatStyleSets, IButtonStyles, useTheme } from '@fluentui/react';
import { SuiteHeaderContext } from './SuiteHeaderProvider';
import { defaultForegroundColor } from './constants';

export const HeaderButton: React.FC<IHeaderButtonProps> = props => {
  const { iconName, children, styles, name, ...rest } = props;
  const context = useContext(SuiteHeaderContext);
  const theme = context.theme;
  const globalTheme = useTheme();
  const mergeStyles = concatStyleSets(styles, {
    root: {
      fontSize: globalTheme.fonts.mediumPlus.fontSize
    }
  });
  const style: IButtonStyles = getStyles(theme, mergeStyles);
  return (
    <CommandBarButton
      {...rest}
      styles={style}
      iconProps={{
        iconName,
        styles: {
          root: {
            color: context.theme?.foregroundColor || defaultForegroundColor,
            height: globalTheme.fonts.mediumPlus.fontSize,
            width: globalTheme.fonts.mediumPlus.fontSize,
            margin: 0
          }
        }
      }}
    >
      {children}
    </CommandBarButton>
  );
};
